import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { TreoAnimations } from 'tsui/@treo';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ReportLayout } from 'app/modules/reports/reports.types';
import { ReportsService } from 'app/modules/reports/reports.service';
import { RelatedToType } from '@shared/enums';

@Component({
  selector: 'report-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ReportAddComponent implements OnInit {
  addContactForm: UntypedFormGroup;
  copyFields: { cc: boolean; bcc: boolean };
  message: any;

  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   *
   * @param {MatDialogRef} matDialogRef
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    public matDialogRef: MatDialogRef<ReportAddComponent>,
    private _reportsService: ReportsService,
    private _router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
    private _formBuilder: UntypedFormBuilder,
  ) {
    this.message = null;

    this._unsubscribeAll = new Subject();
    // Set the default
    this.copyFields = {
      cc: false,
      bcc: false,
    };
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Create the form
    this.addContactForm = this._formBuilder.group({
      name: ['', [Validators.required]],
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Save and close
   */
  saveAndClose(): void {
    let reportLayout = this.addContactForm.getRawValue();
    reportLayout.definition = JSON.stringify({
      related_to_type: RelatedToType.Project,
      charts: [],
      overview: { fields: [], config: {} },
      pipeline: {
        fields: [],
        config: {
          groupings: ['project_stage_id'],
          show_comments: true,
          include_child_deals: false,
          sort_by: { field: 'updated_at', order: 'desc' },
        },
      },
    });
    // Update the contact on the server
    this._reportsService
      .createReport({
        ...reportLayout,
        report_type: 'legacy',
      })
      .subscribe(
        (rl) => {
          // Close the dialog
          this._router.navigate(['/reports/', rl.id]);
          this.matDialogRef.close();
        },
        (response) => {
          // Show the error message
          this.message = {
            appearance: 'outline',
            content: response.error.message,
            showIcon: false,
            type: 'error',
          };
        },
      );
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  /**
   * Save the message as a draft
   */
  saveAsDraft(): void {}

  /**
   * Send the message
   */
  send(): void {}
}
